(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-brand-footer"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const selector = '[data-bf-footer]';
    const instances = new WeakMap();

    function readHex(value) {
      const hex = value.trim().replace('#', '');

      if (!/^[0-9a-f]{6}$/i.test(hex)) {
        return null;
      }

      return [
        parseInt(hex.slice(0, 2), 16),
        parseInt(hex.slice(2, 4), 16),
        parseInt(hex.slice(4, 6), 16)
      ];
    }

    function luminance(rgb) {
      return rgb
        .map((channel) => {
          const value = channel / 255;

          return value <= 0.04045
            ? value / 12.92
            : Math.pow((value + 0.055) / 1.055, 2.4);
        })
        .reduce(
          (total, value, index) => {
            const weights = [0.2126, 0.7152, 0.0722];
            return total + value * weights[index];
          },
          0
        );
    }

    function updateContrast(root) {
      const style = getComputedStyle(root);
      const customColor = style.getPropertyValue('--bf-wordmark-custom').trim();

      if (root.dataset.autoContrast !== 'true') {
        root.style.setProperty('--bf-wordmark-render', customColor);
        return;
      }

      const topColor = style.getPropertyValue('--bf-bg-top').trim();
      const rgb = readHex(topColor);

      if (!rgb) {
        root.style.setProperty('--bf-wordmark-render', customColor);
        return;
      }

      const lightBackground = luminance(rgb) > 0.35;

      root.style.setProperty(
        '--bf-wordmark-render',
        lightBackground ? '#111827' : '#FFFFFF'
      );
    }

    function fitWordmark(root) {
      const wordmark = root.querySelector('[data-bf-wordmark]');

      if (!wordmark) return;

      const wrapper = wordmark.parentElement;
      const styles = getComputedStyle(root);

      const mobile = window.matchMedia('(max-width: 749px)').matches;

      const variable = mobile
        ? '--bf-wordmark-mobile'
        : '--bf-wordmark-desktop';

      const baseSize = parseFloat(styles.getPropertyValue(variable));

      if (!Number.isFinite(baseSize) || baseSize <= 0) return;

      wordmark.style.fontSize = baseSize + 'px';

      const availableWidth = wrapper.clientWidth;
      const actualWidth = wordmark.getBoundingClientRect().width;

      if (!availableWidth || !actualWidth) return;

      const ratio = Math.min(1, availableWidth / actualWidth);
      const finalSize = Math.max(1, baseSize * ratio);

      wordmark.style.fontSize = finalSize + 'px';
    }

    function initialize(root) {
      if (instances.has(root)) {
        updateContrast(root);
        fitWordmark(root);
        return;
      }

      const instance = {
        observer: null,
        controller: new AbortController()
      };

      instances.set(root, instance);

      const refresh = () => {
        updateContrast(root);
        fitWordmark(root);
      };

      refresh();

      if ('ResizeObserver' in window) {
        instance.observer = new ResizeObserver(refresh);

        const wrapper = root.querySelector('.bf-footer__wordmark-wrap');

        if (wrapper) {
          instance.observer.observe(wrapper);
        }
      }

      window.addEventListener('resize', refresh, {
        passive: true,
        signal: instance.controller.signal
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (root.isConnected && instances.has(root)) {
            refresh();
          }
        });
      }
    }

    function destroy(root) {
      const instance = instances.get(root);

      if (!instance) return;

      instance.observer?.disconnect();
      instance.controller.abort();

      instances.delete(root);
    }

    function initializeAll(container) {
      if (container.matches?.(selector)) {
        initialize(container);
      }

      container.querySelectorAll?.(selector).forEach(initialize);
    }

    function destroyAll(container) {
      if (container.matches?.(selector)) {
        destroy(container);
      }

      container.querySelectorAll?.(selector).forEach(destroy);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyAll(event.target);
    });

    document.addEventListener('shopify:section:select', (event) => {
      initializeAll(event.target);
    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gold-standard-stats"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const states = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function formatNumber(value, decimals) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    }

    function getCounters(root) {
      return Array.from(root.querySelectorAll('[data-gsn-count]')).map((element) => {
        const rawTarget = Number(element.dataset.target);
        const rawDecimals = Number(element.dataset.decimals);

        return {
          element,
          target: Number.isFinite(rawTarget) ? Math.max(0, rawTarget) : 0,
          decimals: Number.isFinite(rawDecimals)
            ? Math.max(0, Math.min(2, Math.floor(rawDecimals)))
            : 0
        };
      });
    }

    function stop(root) {
      const state = states.get(root);

      if (!state) return;

      if (state.observer) {
        state.observer.disconnect();
      }

      if (state.frame !== null) {
        cancelAnimationFrame(state.frame);
      }

      states.delete(root);
    }

    function setFinalValues(counters) {
      counters.forEach((counter) => {
        counter.element.textContent = formatNumber(counter.target, counter.decimals);
      });
    }

    function startAnimation(state) {
      if (state.started) return;

      state.started = true;

      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }

      const counters = state.counters;
      const duration = state.duration;

      const startTime = performance.now();

      function animate(now) {
        if (!state.root.isConnected) {
          stop(state.root);
          return;
        }

        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const eased = 1 - Math.pow(1 - progress, 4);

        counters.forEach((counter) => {
          const value = counter.target * eased;

          counter.element.textContent = formatNumber(
            progress === 1 ? counter.target : value,
            counter.decimals
          );
        });

        if (progress < 1) {
          state.frame = requestAnimationFrame(animate);
        } else {
          state.frame = null;
          setFinalValues(counters);
        }
      }

      counters.forEach((counter) => {
        counter.element.textContent = formatNumber(0, counter.decimals);
      });

      state.frame = requestAnimationFrame(animate);
    }

    function initialize(root) {
      stop(root);

      const counters = getCounters(root);

      if (!counters.length) return;

      const animateEnabled = root.dataset.gsnAnimate === 'true';
      const durationValue = Number(root.dataset.gsnDuration);

      const state = {
        root,
        counters,
        started: false,
        observer: null,
        frame: null,
        duration: Number.isFinite(durationValue)
          ? Math.max(100, durationValue)
          : 1600
      };

      states.set(root, state);

      if (!animateEnabled || reducedMotion.matches) {
        setFinalValues(counters);
        return;
      }

      counters.forEach((counter) => {
        counter.element.textContent = formatNumber(0, counter.decimals);
      });

      if (!('IntersectionObserver' in window)) {
        startAnimation(state);
        return;
      }

      state.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            startAnimation(state);
          }
        },
        {
          threshold: 0.1
        }
      );

      state.observer.observe(root);
    }

    function findSections(container) {
      const sections = [];

      if (container.matches && container.matches('.gsn-hero')) {
        sections.push(container);
      }

      if (container.querySelectorAll) {
        sections.push(...container.querySelectorAll('.gsn-hero'));
      }

      return sections;
    }

    function initializeAll(container) {
      findSections(container).forEach(initialize);
    }

    function cleanupAll(container) {
      findSections(container).forEach(stop);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      cleanupAll(event.target);
    });

    document.addEventListener('shopify:section:select', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('.gsn-hero');

      if (root) {
        initialize(root);
      }
    });

    reducedMotion.addEventListener('change', () => {
      initializeAll(document);
    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["longevity-stack"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__longevityStackV3Bound) return;
  window.__longevityStackV3Bound = true;
  const instances = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const wideQuery = window.matchMedia('(min-width: 1200px)');
  // Common sticky header wrappers across themes (Dawn, Horizon, Relvo and most others)
  const HEADER_SELECTORS = '.shopify-section-group-header-group, #shopify-section-header, .header-section, sticky-header, header-component, body > header, header[role="banner"]';
  let headers = null;
  let headerValue;
  let followUntil = 0;
  let followFrame = 0;

  const px = value => {
    const number = parseFloat(value);
    return Number.isFinite(number) ? number : 0;
  };

  function rootsInside(node) {
    const roots = [];
    if (node && node.matches && node.matches('[data-im-stack]')) roots.push(node);
    if (node && node.querySelectorAll) roots.push(...node.querySelectorAll('[data-im-stack]'));
    return roots;
  }

  // The element that actually sticks: the header itself or the section wrapping it
  function findHeaders() {
    const found = new Set();
    document.querySelectorAll(HEADER_SELECTORS).forEach(element => {
      if (element.closest('[data-im-stack]')) return;
      for (let node = element; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
        const position = getComputedStyle(node).position;
        if (position === 'sticky' || position === 'fixed') { found.add(node); return; }
      }
    });
    return [...found];
  }

  // Visible bottom edge of the sticky header. Follows shrinking and hide-on-scroll headers.
  function readHeader() {
    if (!headers || headers.some(element => !element.isConnected)) headers = findHeaders();
    if (!headers.length) return null;
    let bottom = 0;
    headers.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.height > 0 && rect.top < window.innerHeight / 3) bottom = Math.max(bottom, rect.bottom);
    });
    return Math.max(0, Math.round(bottom));
  }

  function setHeader(state) {
    if (headerValue === null || headerValue === undefined) state.root.style.removeProperty('--im-header-offset');
    else state.root.style.setProperty('--im-header-offset', headerValue + 'px');
  }

  function applyHeader(force = false) {
    if (!instances.size) return;
    const value = readHeader();
    if (!force && value === headerValue) return;
    headerValue = value;
    instances.forEach(state => {
      setHeader(state);
      readPins(state);
      sync(state);
    });
  }

  // Check the header every frame while scrolling and briefly after, so offsets track its animation
  function followHeader() {
    followUntil = performance.now() + 450;
    if (followFrame) return;
    const tick = () => {
      applyHeader();
      followFrame = performance.now() < followUntil ? requestAnimationFrame(tick) : 0;
    };
    followFrame = requestAnimationFrame(tick);
  }

  function stopNavigation(state) {
    state.navigation = null;
    state.cards.forEach((card, index) => { card.style.zIndex = String(index + 1); });
  }

  function cleanup(root) {
    const state = instances.get(root);
    if (!state) return;
    state.controller.abort();
    if (state.frame) cancelAnimationFrame(state.frame);
    if (state.resizeFrame) cancelAnimationFrame(state.resizeFrame);
    if (state.resizeObserver) state.resizeObserver.disconnect();
    state.cards.forEach(card => { card.style.zIndex = ''; card.style.minHeight = ''; });
    ['--im-header-offset', '--im-rail-height', '--im-rail-release'].forEach(name => root.style.removeProperty(name));
    instances.delete(root);
  }

  function activate(state, active) {
    state.rows.forEach((row, index) => {
      const selected = index === active;
      row.classList.toggle('is-active', selected);
      row.setAttribute('aria-current', String(selected));
    });
  }

  function readPins(state) {
    state.pins = state.cards.map(card => px(getComputedStyle(card).top));
  }

  function measure(state) {
    if (state.controller.signal.aborted) return;
    const { root, cards, intro, railWrap, track } = state;
    const pinIntro = mobileQuery.matches && intro && root.classList.contains('im-stack--pin-intro');

    // Pinned mobile heading: cards stack right under its real height
    if (pinIntro) {
      const introHeight = Math.ceil(intro.offsetHeight);
      if (introHeight > 0) root.style.setProperty('--im-intro-height', introHeight + 'px');
    }

    // Equal heights on every screen size, so all cards finish together and the stack leaves as one piece
    cards.forEach(card => { card.style.minHeight = ''; });
    const tallest = Math.max(...cards.map(card => Math.ceil(card.offsetHeight)));
    cards.forEach(card => { card.style.minHeight = tallest + 'px'; });
    readPins(state);

    // Where the bottom of the stack sits (from the top of the screen) at the moment it starts to leave
    const releaseBottom = state.pins[cards.length - 1] + tallest;
    root.style.removeProperty('--im-rail-height');
    root.style.removeProperty('--im-rail-release');

    if (pinIntro && railWrap && track) {
      // Size the heading's wrapper so the heading lets go at the same moment as the cards
      const introTop = px(getComputedStyle(intro).top);
      const railHeight = track.offsetHeight - releaseBottom + introTop + intro.offsetHeight;
      root.style.setProperty('--im-rail-height', Math.max(0, Math.round(railHeight)) + 'px');
    } else if (wideQuery.matches && railWrap) {
      // Desktop menu: extend its sticky range to end exactly when the cards leave
      const railTop = px(getComputedStyle(railWrap).top);
      const release = releaseBottom - railTop - railWrap.offsetHeight;
      root.style.setProperty('--im-rail-release', Math.max(0, Math.round(release)) + 'px');
    }
    sync(state);
  }

  function scheduleMeasure(state) {
    if (state.resizeFrame) return;
    state.resizeFrame = requestAnimationFrame(() => {
      state.resizeFrame = 0;
      measure(state);
    });
  }

  function sync(state) {
    if (state.controller.signal.aborted) return;
    const scrollPosition = window.scrollY;
    if (state.navigation) {
      const nav = state.navigation;
      // Keep the clicked item active until the smooth scroll reaches its target
      if (Math.abs(scrollPosition - nav.target) <= 5 || performance.now() - nav.started > 2400) {
        stopNavigation(state);
      } else {
        activate(state, nav.index);
        return;
      }
    }
    let active = 0;
    for (let i = 0; i < state.cards.length; i++) {
      const anchorTop = state.anchors[i].getBoundingClientRect().top;
      if (anchorTop <= state.pins[i] + 5) active = i;
    }
    activate(state, active);
  }

  function onScroll(state) {
    if (state.frame) return;
    state.frame = requestAnimationFrame(() => {
      state.frame = 0;
      sync(state);
    });
  }

  function goTo(state, index, editorSelection = false) {
    const card = state.cards[index];
    const anchor = state.anchors[index];
    if (!card || !anchor) return;
    const pin = px(getComputedStyle(card).top) || state.pins[index] || 0;
    const target = Math.max(0, Math.round(anchor.getBoundingClientRect().top + window.scrollY - pin));
    stopNavigation(state);
    state.navigation = { index, target, started: performance.now() };
    card.style.zIndex = String(state.cards.length + 50);
    activate(state, index);
    window.scrollTo({ top: target, behavior: editorSelection || reducedMotion.matches ? 'instant' : 'smooth' });
    if (editorSelection || reducedMotion.matches) {
      requestAnimationFrame(() => {
        stopNavigation(state);
        sync(state);
      });
    }
  }

  function init(root) {
    cleanup(root);
    const cards = [...root.querySelectorAll('[data-im-stack-card]')];
    const anchors = [...root.querySelectorAll('[data-im-stack-anchor]')];
    const rows = [...root.querySelectorAll('[data-im-rail-row]')];
    if (!cards.length || anchors.length !== cards.length) return;
    const controller = new AbortController();
    const state = {
      root, cards, anchors, rows, controller,
      intro: root.querySelector('[data-im-intro]'),
      railWrap: root.querySelector('[data-im-rail-wrap]'),
      track: root.querySelector('[data-im-stack-track]'),
      navigation: null, pins: [], frame: 0, resizeFrame: 0, resizeObserver: null
    };
    instances.set(root, state);
    const signal = controller.signal;
    cards.forEach((card, index) => {
      card.style.zIndex = String(index + 1);
      card.addEventListener('click', event => {
        if (event.target.closest('a, button')) return;
        goTo(state, index);
      }, { signal });
      card.addEventListener('keydown', event => {
        if (event.target !== card) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goTo(state, index);
        }
      }, { signal });
    });
    rows.forEach((row, index) => {
      row.addEventListener('click', () => goTo(state, index), { signal });
    });
    window.addEventListener('scroll', () => onScroll(state), { passive: true, signal });
    window.addEventListener('resize', () => scheduleMeasure(state), { passive: true, signal });
    window.addEventListener('wheel', () => {
      if (state.navigation) { stopNavigation(state); onScroll(state); }
    }, { passive: true, signal });
    window.addEventListener('touchstart', () => {
      if (state.navigation) { stopNavigation(state); onScroll(state); }
    }, { passive: true, signal });
    // Re-measure when content changes size: images loading, fonts, editor changes
    if ('ResizeObserver' in window) {
      state.resizeObserver = new ResizeObserver(() => scheduleMeasure(state));
      state.resizeObserver.observe(state.track);
      if (state.intro) state.resizeObserver.observe(state.intro);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!signal.aborted) scheduleMeasure(state);
      });
    }
    headers = null;
    if (headerValue === undefined) headerValue = readHeader();
    setHeader(state);
    measure(state);
  }

  function initAll(target) { rootsInside(target).forEach(init); }
  function cleanupAll(target) { rootsInside(target).forEach(cleanup); }

  window.addEventListener('scroll', followHeader, { passive: true });
  window.addEventListener('resize', () => { headers = null; followHeader(); }, { passive: true });
  window.addEventListener('load', () => { headers = null; applyHeader(true); instances.forEach(scheduleMeasure); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', event => {
    headers = null;
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', event => cleanupAll(event.target));
  document.addEventListener('shopify:section:select', event => {
    rootsInside(event.target).forEach(root => {
      const state = instances.get(root);
      if (state) scheduleMeasure(state);
      else init(root);
    });
  });
  document.addEventListener('shopify:block:select', event => {
    const block = event.target.closest?.('[data-im-stack-card]') || event.target.querySelector?.('[data-im-stack-card]');
    if (!block) return;
    const root = block.closest('[data-im-stack]');
    if (!root) return;
    if (!instances.has(root)) init(root);
    const state = instances.get(root);
    if (state) {
      const index = state.cards.indexOf(block);
      if (index >= 0) goTo(state, index, true);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
